import { render, staticRenderFns } from "./LatestObituaries.vue?vue&type=template&id=508472f0&scoped=true"
import script from "./LatestObituaries.vue?vue&type=script&lang=js"
export * from "./LatestObituaries.vue?vue&type=script&lang=js"
import style0 from "./LatestObituaries.vue?vue&type=style&index=0&id=508472f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508472f0",
  null
  
)

export default component.exports